import { useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

type Status = 'success' | 'error' | 'missing';

export function TransbankCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const status: Status = useMemo(() => {
    const raw = searchParams.get('status');
    if (raw === 'success') return 'success';
    if (raw === 'error') return 'error';
    return 'missing';
  }, [searchParams]);

  const paymentMethodId = searchParams.get('paymentMethodId');
  const errorMessage = searchParams.get('message');

  const handleBack = () => {
    navigate('/sucursal-virtual', { replace: true });
  };

  const handleRetry = () => {
    navigate('/sucursal-virtual', { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#FFDCE6] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-lg p-10 flex flex-col items-center gap-4 max-w-sm w-full text-center">
        <div
          className={
            'w-14 h-14 rounded-full flex items-center justify-center ' +
            (status === 'success'
              ? 'bg-green-100'
              : 'bg-red-100')
          }
        >
          {status === 'success' ? (
            <svg
              className="w-7 h-7 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <svg
              className="w-7 h-7 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          )}
        </div>

        {status === 'success' && (
          <>
            <p className="text-green-700 font-semibold text-lg">
              Tarjeta agregada correctamente
            </p>
            <p className="text-sm text-gray-500">
              Tu tarjeta fue inscrita con Transbank y ya puedes usarla para pagar tus suscripciones.
            </p>
            {paymentMethodId && (
              <p className="text-xs text-gray-400 break-all">
                ID: {paymentMethodId}
              </p>
            )}
          </>
        )}

        {status === 'error' && (
          <>
            <p className="text-red-600 font-semibold text-lg">
              No se pudo agregar la tarjeta
            </p>
            <p className="text-sm text-gray-500">
              {errorMessage ??
                'Ocurrió un problema al confirmar la inscripción con Transbank. Intenta nuevamente.'}
            </p>
          </>
        )}

        {status === 'missing' && (
          <>
            <p className="text-red-600 font-semibold text-lg">
              Información incompleta
            </p>
            <p className="text-sm text-gray-500">
              No recibimos los datos de Transbank. Por favor vuelve a intentar el proceso.
            </p>
          </>
        )}

        <div className="flex flex-col gap-2 w-full mt-4">
          {status === 'success' ? (
            <button
              onClick={handleBack}
              className="w-full bg-[#FF6F61] hover:bg-[#FF6F61]/90 text-white font-medium rounded-xl py-3 transition-colors"
            >
              Volver a mi cuenta
            </button>
          ) : (
            <>
              <button
                onClick={handleRetry}
                className="w-full bg-[#FF6F61] hover:bg-[#FF6F61]/90 text-white font-medium rounded-xl py-3 transition-colors"
              >
                Reintentar
              </button>
              <button
                onClick={handleBack}
                className="w-full border border-gray-200 text-gray-600 hover:bg-gray-50 font-medium rounded-xl py-3 transition-colors"
              >
                Volver a mi cuenta
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
